import React, { useState, useEffect } from "react"
import { Box, Container } from "./styles"
//import { Container } from "./styles"
import Logo from "../../assets/itvLogo.svg";
import { navigate } from 'hookrouter';
import { LoginBG } from '../../config/api'
import LogoAtlas from "../../assets/atlasBHRILogoCompleto.svg";

//const login = "desenv2"
//const password = "desenv2"
const Login = () => {

    const [error, setError] = useState(false)
    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')
    useEffect(() => {
        setError(false)
    }, [login, password])

    const entrar = async () => {
        const response = await LoginBG("webuser", "desenv2")
        if (response.status === 200) {
            sessionStorage.setItem('logado', true)
            navigate("/")
        } else {
            sessionStorage.setItem('logado', false)
            setError('Erro Login')
        }
    }

    const keyUp = (e) => {
        if (e.keyCode === 13)
            entrar()
    }

    //entrar()

    return (

        //<Container onLoad={() => entrar()}>
        <Container>
            <Box>
            <img src={Logo} alt="ITV logo" />
                {/* <h1>Atlas Geoquímico</h1>
                <h3>Bacia Hidrográfica do Rio Itacaiúnas</h3> */}
                <img
                    src={LogoAtlas}
                    alt="Atlas Geoquímico da Bacia Hidrográfica do Rio Itacaiúnas"
                />
                {error && <p>{error}</p>}
                <input
                    type="text"
                    placeholder="Login"
                    value={login}
                    onChange={e => setLogin(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Senha"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyUp={e => keyUp(e)}
                />
                <button type="button" onClick={() => entrar()}>Entrar</button>
                {/* <hr /> */}
                {/* <Link to="/signup">Criar conta</Link> */}
            </Box>

        </Container>
    )


}

export default Login